import { ConditionalWrap } from "@1js/pl-card-components";
import * as React from "react";
import { useSwipe } from "../../hooks/useCarousel/useSwipe";
import useMedia from "../../hooks/useMedia/useMedia";
import { Carousel } from "../Carousel/Carousel.web";
import type { Video, VideoCarouselProps } from "./VideoCarousel.web.data";
import { useStyles } from "./VideoCarousel.web.styles";
import { CarouselItem } from "./VideoCarouselItem.web";
import { VideoPlayerDialog } from "./VideoPlayerDialog";

const mapVideostoCarouselItems = (
  videos: Video[],
  setOpen: (arg: boolean) => void,
  setActiveVideo: (arg: Video) => void,
  isSwiped: boolean
) => {
  return videos.map((video, idx) => (
    <CarouselItem
      key={video.id}
      video={video}
      id={idx === 0 ? "mainContent" : undefined}
      onClick={() => {
        if (!isSwiped) {
          setOpen(true);
          setActiveVideo(video);
        }
      }}
    />
  ));
};

export const VideoCarousel: React.FC<VideoCarouselProps> = ({
  videos,
  locale,
}) => {
  const styles = useStyles();
  const isDesktop = useMedia({ minWidth: "954px" });
  const [open, setOpen] = React.useState(false);
  const [activeVideo, setActiveVideo] = React.useState<Video | undefined>(
    undefined
  );
  const swipe = useSwipe();

  return (
    <div className={styles.root} role="list">
      <ConditionalWrap
        condition={!isDesktop}
        wrapIfTrue={(children) => (
          <Carousel id="video" setSwipedState={swipe.setSwipedState}>
            {children}
          </Carousel>
        )}
        wrapIfFalse={(children) => <div className={styles.ul}>{children}</div>}
      >
        {mapVideostoCarouselItems(
          videos,
          setOpen,
          setActiveVideo,
          swipe.isSwiped
        )}
      </ConditionalWrap>
      <VideoPlayerDialog
        open={open}
        onClosed={() => {
          setOpen(false);
        }}
        video={activeVideo}
        locale={locale}
      />
    </div>
  );
};
